import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSectionOpen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 14 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		opacity: .8,
		d: "M7.97613 8.89238L12.9427 1.56085C13.3925 0.896812 12.9168 -4.73488e-08 12.1147 -8.24077e-08L1.11743 -5.63115e-07C0.272577 -6.00045e-07 -0.191569 0.982797 0.345141 1.63527L6.37592 8.96681C6.80029 9.48271 7.60147 9.44545 7.97613 8.89238Z",
		fill: "black"
	})
});
export default SvgSectionOpen;
